module.exports = __webpack_public_path__ + "static/assets/1bff35b71e6f52017b123be4f9904d54.mp3";